// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1zQqF","img":"hero-module--img--1Roo1"};